import { normalizeQuery } from "@/lib/analytics/search-normalize";
import { MIN_SEARCH_LENGTH } from "@/lib/constants/search";

/** Default debounce before a query is considered "settled". */
export const SEARCH_SETTLE_DEBOUNCE_MS = 1000;

/**
 * Returns true when a normalized query should emit a new `search_performed` event.
 * Skips queries below min length and repeats of the last emitted normalized query.
 */
export function shouldEmitSettledQuery(
  rawQuery: string,
  lastEmittedNormalizedQuery: string | null
): boolean {
  const normalized = normalizeQuery(rawQuery);
  if (normalized.length < MIN_SEARCH_LENGTH) {
    return false;
  }
  if (normalized === lastEmittedNormalizedQuery) {
    return false;
  }
  return true;
}
